import StudentPersonalInformation from '../../../../../updateStudentFile/parts/studentPersonalInfo/StudentPersonalInformation';

const StudentInformationGroup = () => {
  return (
    <div className="w-100 d-flex flex-column mt-3" style={{ gap: 12 }}>
      <div
        style={{
          position: 'relative',
          transform: 'translateX(-1rem)',
          width: 'calc(100% + 2rem)',
        }}
        className="mt-2"
      >
        <StudentPersonalInformation showHeader={false} showActions={false} />
      </div>
    </div>
  );
};

export default StudentInformationGroup;
